"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkDriveService = void 0;
const core_1 = require("@angular/core");
let NetworkDriveService = class NetworkDriveService {
    constructor() {
        this.storageKey = 'webos-network-drives';
        this.drives = (0, core_1.signal)([]);
        this.loadDrivesFromStorage();
        (0, core_1.effect)(() => {
            this.saveDrivesToStorage(this.drives());
        });
    }
    loadDrivesFromStorage() {
        try {
            const storedDrives = localStorage.getItem(this.storageKey);
            if (storedDrives) {
                this.drives.set(JSON.parse(storedDrives));
            }
        }
        catch (e) {
            console.error('Failed to load network drives from localStorage', e);
        }
    }
    saveDrivesToStorage(drives) {
        try {
            localStorage.setItem(this.storageKey, JSON.stringify(drives));
        }
        catch (e) {
            console.error('Failed to save network drives to localStorage', e);
        }
    }
    mountDrive(name, path) {
        if (this.drives().some(drive => drive.name.toLowerCase() === name.toLowerCase())) {
            alert(`A drive with the name "${name}" already exists.`);
            return false;
        }
        if (!path.includes(':/')) {
            alert(`Invalid path. Path should be a valid root like "C:/".`);
            return false;
        }
        this.drives.update(drives => [...drives, { name, path }]);
        return true;
    }
    unmountDrive(name) {
        this.drives.update(drives => drives.filter(drive => drive.name !== name));
    }
};
exports.NetworkDriveService = NetworkDriveService;
exports.NetworkDriveService = NetworkDriveService = __decorate([
    (0, core_1.Injectable)({ providedIn: 'root' }),
    __metadata("design:paramtypes", [])
], NetworkDriveService);
